import { Injectable, Injector } from '@angular/core';
import { LayerThematicStylesDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { BaseService } from '@common-modules/shared/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThematicsService extends BaseService {
  private _entityUrl: string;

  constructor(injector: Injector) {
    super(injector);
    this._entityUrl = `${this.apiUrl}/map/styles`;
  }

  upsertThematic(thematic: LayerThematicStylesDto, id?: string): Observable<string> {
    const url = id ? `${this._entityUrl}/thematics/${id}` : `${this._entityUrl}/thematics`;
    return this.httpCacheClient.post<string>(url, thematic);
  }

  deleteThematic(id: string): Observable<boolean> {
    const url = `${this._entityUrl}/thematics/${id}`;
    return this.httpCacheClient.delete<boolean>(url);
  }
}
